'use client'

import { useIsFirstRender, usePrevious } from '@mntn-dev/ui-utilities'
import { useEffect } from 'react'

export const PopoverListener = ({
  onClose,
  onOpen,
  open,
}: { open: boolean; onClose?: () => void; onOpen?: () => void }) => {
  const isFirstRender = useIsFirstRender()
  const previousOpen = usePrevious(open)

  useEffect(() => {
    if (!isFirstRender && open !== previousOpen) {
      if (!open) {
        onClose?.()
      }
      if (open) {
        onOpen?.()
      }
    }
  }, [isFirstRender, previousOpen, open, onClose, onOpen])

  return null
}
